import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';

import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import fieldStyles from '../../styles/fieldStyles';
import ApiService from '../../services/ApiService';
import { dbToDate, dbToTime } from '../../utils/dateTime';
import { useEffect } from 'react';

export default function DialogIncidentAlert({
  dialogOpen,
  handleCloseDialog,
  data,
  type,
  title,
  setFailMessage,
  setOpen3,
  setOpen2,
  setAlertOpen,
}) {
  const [inputFields, setInputFields] = useState({
    uploadDocumentList: [],
  });

  const handleInputFile = async (e) => {
    // Set Loading
    setUploadDoc(true);

    // Baca File
    const files = e.target.files[0];

    // Init
    var formData = new FormData();

    // Cek ukuran file
    if (files.size > 1024 * 1024 * 20) {
      alert('Ukuran file maximum 20 Mb.');
      return;
    }

    formData.append('file', files);

    if (type === 'Create' && title === 'Learning Event') {
      try {
        // Mengirimkan file (formData)
        await ApiService.postUploadLfe(formData)
          .then((upload) => {
            const newUpload = upload.data.payload;
            console.log('newUpload CLE', newUpload);

            // Memasang respond
            setInputFields({
              ...inputFields,
              uploadDocumentList: [
                {
                  fileZise: newUpload[0].fileZise,
                  id: newUpload[0].id,
                  idLfe: 0,
                  isDelete: newUpload[0].isDelete,
                  url: newUpload[0].url,
                },
              ],
            });
            // setMedia((old) => {
            //   return [...old, newUpload[0]];
            // });
          })
          .catch((error) => {
            console.log('error', error);
          });
      } catch (error) {
        console.log('error', error);
      }
    }
    // Incident Alert
    else if (type === 'Create' && title === 'Incident Alert') {
      try {
        // Mengirimkan file (formData)
        await ApiService.postUploadIa(formData)
          .then((upload) => {
            const newUpload = upload.data.payload;
            console.log('newUpload IA', newUpload);

            // Memasang respond
            setInputFields({
              ...inputFields,
              uploadDocumentList: [
                {
                  fileZise: newUpload[0].fileZise,
                  id: newUpload[0].id,
                  idIncidentAlert: 0,
                  isDelete: newUpload[0].isDelete,
                  url: newUpload[0].url,
                },
              ],
            });
          })
          .catch((error) => {
            console.log('error', error);
          });
      } catch (error) {
        console.log('error', error);
      }
    }

    setUploadDoc(false);
  };

  const handleRemoveFile = (id) => {
    // let temp = inputFields.uploadDocumentList.splice(idx, 1);

    setInputFields({
      ...inputFields,
      uploadDocumentList: inputFields.uploadDocumentList.filter(
        (item) => item.id !== id
      ),
    });
  };

  // Loading Button
  const [uploadDoc, setUploadDoc] = useState(false);

  // Select
  const [kepada, setKepada] = useState(1);
  const handleChange = (event) => {
    setKepada(event.target.value);
  };

  // Action Button
  const [sendLoad, setSendLoad] = useState(false);
  const handleSend = () => {
    setSendLoad(true);

    if (type === 'Create' && title === 'Learning Event') {
      const finalValue = {
        idLkp: data.idTblLkp,
        remark: '',
        uploadDocumentList: inputFields.uploadDocumentList,
      };

      console.log('post CLE', finalValue);

      ApiService.postIncimanLfe(finalValue)
        .then((res) => {
          if (!res.data.isOk) {
            setFailMessage(res.data.message);
            setOpen3(true);
          } else {
            setOpen2(true);
            setAlertOpen(false);
            window.location.reload();
          }
        })
        .catch((err) => {
          setOpen3(true);
        });
      // Incident Alert
    } else if (type === 'Create' && title === 'Incident Alert') {
      const finalValue = {
        idLkp: data.idTblLkp,
        remark: '',
        uploadDocumentList: inputFields.uploadDocumentList,
      };

      console.log('post IA', finalValue);

      ApiService.postIncimanIa(finalValue)
        .then((res) => {
          if (!res.data.isOk) {
            setFailMessage(res.data.message);
            setOpen3(true);
          } else {
            setOpen2(true);
            setAlertOpen(false);
            window.location.reload();
          }
        })
        .catch((err) => {
          console.log('err', err);
          setOpen3(true);
        });
    }

    setSendLoad(false);
  };

  useEffect(() => {
    const getData = async () => {
      let res;

      if (title === 'Incident Alert') {
        res = await ApiService.getIncimanIa(data.idIncidentAlert);
      } else if (title === 'Learning Event') {
        res = await ApiService.getIncimanLfe(data.idLearningFromEvent);
      }

      setInputFields(res.data.payload);
    };

    console.log('data', data);
    if (type === 'View') {
      getData();
    }
  }, []);

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      maxWidth={'sm'}
      fullWidth={true}
    >
      <DialogTitle
        sx={{
          bgcolor: 'red',
          color: 'white',
          m: 2,
          p: 2,
          textAlign: 'center',
          borderRadius: '5px',
        }}
      >
        {title === 'Incident Alert' && type === 'Create'
          ? 'Incident Alert'
          : type + ' ' + title}
      </DialogTitle>
      <DialogContent>
        {title === 'Incident Alert' ? (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'col',
                width: '100%',
                marginBottom: '10px',
              }}
            >
              <div style={{ textAlign: 'start', width: '100%' }}>
                <small>No LKP</small>
                <br />
                <span style={{ fontSize: '16px', lineHeight: '22px' }}>
                  {data.nomorLkp}
                </span>
              </div>
              <div style={{ textAlign: 'end', width: '100%' }}>
                <small>Date Reported</small>
                <br />
                <span style={{ fontSize: '15px' }}>
                  {dbToDate(data.tanggalLaporan)}
                </span>
              </div>
            </div>

            <div
              style={{
                marginBottom: '10px',
              }}
            >
              <small>Judul</small>
              <br />
              <b style={{ fontSize: '20px', lineHeight: '26px' }}>
                {data.judulLaporan}
              </b>
            </div>

            <div
              style={{
                marginBottom: '20px',
              }}
            >
              <small>Tipe Incident</small>
              <br />
              <b style={{ fontSize: '20px', lineHeight: '26px' }}>
                {data.tipeInsiden}
              </b>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'col',
                width: '100%',
                marginBottom: '3px',
              }}
            >
              <div style={{ textAlign: 'start', width: '100%' }}>
                <small>Nomor LKP : </small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{data.nomorLkp}</b>
                </span>
              </div>
              <div style={{ width: '100%' }}>
                <small>Tanggal Kejadian :</small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{dbToDate(data.tanggalKejadian)}</b>
                </span>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'col',
                width: '100%',
                marginBottom: '3px',
              }}
            >
              <div style={{ textAlign: 'start', width: '100%' }}>
                <small>Judul : </small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{data.judulLaporan}</b>
                </span>
              </div>
              <div style={{ width: '100%' }}>
                <small>Jam Kejadian :</small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{dbToTime(data.tanggalKejadian)}</b>
                </span>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'col',
                width: '100%',
                marginBottom: '3px',
              }}
            >
              <div style={{ textAlign: 'start', width: '100%' }}>
                <small>Lokasi : </small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{data.namaLokasi}</b>
                </span>
              </div>
              <div style={{ width: '100%' }}>
                <small>Kategori Insiden :</small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{data.tipeInsiden}</b>
                </span>
              </div>
            </div>

            <div
              style={{
                width: '100%',
                marginBottom: '20px',
              }}
            >
              <div style={{ textAlign: 'start', width: '100%' }}>
                <small>Region : </small>
                <br />
                <span style={{ fontSize: '16px' }}>
                  <b>{data.namaRegional}</b>
                </span>
              </div>
            </div>
          </>
        )}

        <Box component="div" sx={fieldStyles}>
          <LoadingButton
            variant="contained"
            component="label"
            loading={uploadDoc}
            startIcon={<SendIcon />}
            loadingPosition="start"
            disabled={type === 'View'}
          >
            Upload Document
            <input
              hidden
              multiple
              accept=".pdf"
              type="file"
              onChange={handleInputFile}
            />
          </LoadingButton>
          <span style={{ color: 'red', marginLeft: '20px' }}>
            <small>* Upload file (.pdf) (Maximum 20 Mb)</small>
          </span>
          <br />
          <br />

          {inputFields.uploadDocumentList.map((doc, idx) => (
            // {media.map((doc, idx) => (
            <div style={{ maxWidth: '100%' }}>
              <Tooltip title={doc.url} palcement="top">
                <span style={{ opacity: '0.8' }}>
                  {idx + 1}.{' '}
                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={async (e) =>
                      await ApiService.viewFile(doc.url, e)
                    }
                  >
                    {doc.url}
                  </a>
                </span>
              </Tooltip>

              <IconButton
                aria-label="delete"
                color="error"
                onClick={() => handleRemoveFile(doc.id)}
                disabled={type === 'View'}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialog} sx={{ width: '100px', m: 1 }}>
          {type === 'Create' ? 'CANCEL' : 'CLOSE'}
        </Button>
        {type === 'Create' && (
          <LoadingButton
            onClick={handleSend}
            loading={sendLoad}
            variant="contained"
            sx={{ width: '100px', m: 1 }}
            startIcon={<SaveIcon />}
            loadingPosition="start"
          >
            SEND
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
}
